import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './page-not-found.component';
import { SharedModule } from '../@shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PageNotFoundRoutingModule } from './page-not-found.routing.module';
import { FooterPageModule } from '../footer/footer-page.module';
import { FooterV2Module } from '../footer-v2/footer-v2.module';

@NgModule({
    declarations: [PageNotFoundComponent],
    imports: [
        CommonModule,
        SharedModule,
        MatProgressSpinnerModule,
        PageNotFoundRoutingModule,
        FooterPageModule,
        FooterV2Module,
    ],
})
export class PageNotFoundModule {}
